import { Flex, Text } from '@buffer-mono/popcorn'

import styles from './EmptyStateExplainerCard.module.css'

import type { JSX } from 'react'

type EmptyStateExplainerCardProps = {
  heading: string
  body: string
}

/**
 * Shared "How it works" explainer shown inside the listening empty state — a
 * sunken, actionless card. Wrappers own the heading/body copy and the condition
 * under which they render, so both first-connect variants stay visually
 * identical.
 */
export function EmptyStateExplainerCard({
  heading,
  body,
}: EmptyStateExplainerCardProps): JSX.Element {
  return (
    <div className={styles.card}>
      <Flex direction="column" gap="xs">
        <Text size="sm" color="subtle" weight="medium">
          How it works
        </Text>
        <Text size="md" weight="medium" color="default">
          {heading}
        </Text>
        <Text size="sm" color="subtle">
          {body}
        </Text>
      </Flex>
    </div>
  )
}
